import React, { FC, MouseEvent } from 'react'
import BEMHelper from '@ynap/bem-helper'
import PaymentCard from '@ynap/payment-card'
import { Card } from 'app/state/wallet-state/state'

const bem = new BEMHelper('Card')
type I18nFunction = (...args: any) => string
type CardProps = {
    messages: {
        card: {
            cardHolder: I18nFunction
            expired: I18nFunction
            expiry: I18nFunction
        }
    }
    className?: string
    onClick?: (event: MouseEvent<HTMLDivElement>) => void
} & Card

type CardHolderProps = {
    name?: string
    first_name?: string
    last_name?: string
}
export const getCardHolder = ({ name, first_name, last_name }: CardHolderProps) =>
    name ? name : first_name || last_name ? `${first_name} ${last_name}` : ''

const WalletCard: FC<CardProps> = ({
    className,
    expired,
    messages,
    type,
    lastFourDigits,
    expiry: { month, year },
    card_holder,
    children,
    onClick,
}) => {
    const cardHolder = getCardHolder(card_holder)

    return (
        <div onClick={onClick} className={bem(null, null, className)}>
            <div className={bem('header')}>
                {cardHolder && <div className={bem('cardHolder')}>{cardHolder}</div>}
                <PaymentCard
                    ariaLabel={type.replace('-', ' ')}
                    as="div"
                    className={bem('type')}
                    card={type.replace('-', '')}
                    key={`cardType-${lastFourDigits}`}
                />
            </div>
            <div className={bem('info')}>
                <div className={bem('cardNumber')}>
                    <div className={bem('dots')}>•••• •••• ••••</div>
                    {lastFourDigits}
                </div>
                <div className={bem('expiry')}>
                    <div className={bem('label', { expired })}>
                        {expired ? messages.card.expired() : messages.card.expiry()}
                    </div>
                    <div className={bem('date', { expired })}> {`${month}/${year}`}</div>
                </div>
            </div>
            {children ? <div className={bem('content')}>{children}</div> : null}
        </div>
    )
}

export default WalletCard
